import { render } from "./RejectedOrBlocked.vue?vue&type=template&id=07f17bca&scoped=true"
import script from "./RejectedOrBlocked.vue?vue&type=script&lang=js"
export * from "./RejectedOrBlocked.vue?vue&type=script&lang=js"

import "./RejectedOrBlocked.vue?vue&type=style&index=0&id=07f17bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f17bca"]])

export default __exports__